import { TogglePlan } from './payment-method.api';

interface DivideResult {
  plansWithThisAssignedMethod: TogglePlan[];
  plansWithOtherMethod: TogglePlan[];
}

interface Props {
  plans: TogglePlan[];
  paymentMethodId: number;
}
export const dividePlansByPaymentMethod = ({
  plans,
  paymentMethodId,
}: Props): DivideResult =>
  plans.reduce(
    (acc, val) => {
      if (val.paymentMethodId === paymentMethodId) {
        acc.plansWithThisAssignedMethod.push(val);
      } else {
        acc.plansWithOtherMethod.push(val);
      }
      return acc;
    },
    {
      plansWithThisAssignedMethod: [] as TogglePlan[],
      plansWithOtherMethod: [] as TogglePlan[],
    }
  );
